<template>
    <div id="EcommerceEnterpriseTotal">

        <img src="@/assets/img/Group3862.png" alt="">
        <div>
            <div class="num">
                <span>{{ num }}</span>
            </div>
            <div class="title">电商企业总数</div>

        </div>
    </div>
</template>

<script>
import {
    lsdRegionEcommerceStatIndex
} from "@/api/home"


export default {
    name: "",
    components: {
    },
    props: {},
    data() {
        return {
            num: 0,
        };
    },
    watch: {},
    computed: {},
    methods: {
        async init() {
            //综试区发展指数-中下
            try {
                const res = await lsdRegionEcommerceStatIndex({})
                this.num = res.data[0].totalEcommerceCount;
            } catch (err) {
                this.$message.error("数据加载失败")
            }

        }
    },
    created() { },
    async mounted() {
        await this.init();
    }
}
</script>
<style lang="scss" scoped>
#EcommerceEnterpriseTotal {
    display: flex;
    gap: 38px;
    line-height: 38px;
    align-items: center;
    text-align: center;
    padding-top: 38px;
    padding-left: 40px;
    z-index: 2;

    .title {
        text-align: left;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 18px;
        color: #D3DEEC;
        line-height: 24px;
        font-style: normal;
        text-transform: none;
        // position: absolute;
        // top: 83px;
    }

    .num {
        font-family: D-DIN-PRO, D-DIN-PRO;
        font-weight: 800;
        font-size: 36px;
        line-height: 40px;
        letter-spacing: 5px;
        margin-bottom: 16px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        background: linear-gradient(90deg, #55FFF5 0%, #DAFFFD 100%);
        /* 渐变色 */
        -webkit-background-clip: text;
        /* 用文字形状裁剪背景 */
        -webkit-text-fill-color: transparent;
        /* 让文字填充透明 */
    }


}
</style>